module.exports = {
    "group":"group"
}


/** WEBPACK FOOTER **
 ** ./~/subschema/src/styles/CheckboxesGroupTemplate-style.js
 **/